module.exports = __webpack_public_path__ + "static/media/facebook_logo.43488265.png";